module.exports = __webpack_public_path__ + "static/07-a51cdbb52100a7ec44ac8d2d6f2cb351.jpg";